import { AxiosResponse } from 'axios';

import API from 'src/services/api';
import { UserEntitlements } from './types';
const authUserAPI = {
  async entitlements(): Promise<AxiosResponse<UserEntitlements>> {
    return API.get('/user/entitlements');
  },
};

export default authUserAPI;
